// extracted by mini-css-extract-plugin
export default {"container":"uK-z","topReviewHeading":"vK-z","criticalReview":"wK-z","favorableReview":"xK-z","vsSeparator":"yK-z"};